import Color, { ColorInstance } from "color";
import isNumber from "lodash/isNumber";
import maxBy from "lodash/maxBy";
import { useTheme } from "PFApp/theme_context_provider/theme_context_provider_context";
import { useThresholds } from "PFCore/hooks/queries/bookings/thresholds/use_thresholds";
import { useMemo } from "react";

import { DEFAULT_OVERBOOKING_COLOR } from "../../parts/helpers";
import { Overbooking } from "../../types";

type UseOverbookingColorProps = { overbookings: Pick<Overbooking, "utilization">[] };
type UseOverbookingColorReturn = {
  overbookingColor: ColorInstance;
};

export const useOverbookingColor = ({
  overbookings
}: UseOverbookingColorProps): UseOverbookingColorReturn => {
  const thresholds = useThresholds(["overbooking"]);
  const { themeVars } = useTheme();

  const overbookingMaxLoad = useMemo(
    () => maxBy(overbookings || [], "utilization")?.utilization,
    [overbookings]
  );

  const overbookingColor = useMemo(() => {
    const backgroundColor: string | undefined =
      (isNumber(overbookingMaxLoad) &&
        thresholds?.overbooking?.find(
          (item) => overbookingMaxLoad * 100 >= item.min && overbookingMaxLoad * 100 <= item.max
        )?.color) ||
      undefined;

    return backgroundColor ? new Color(backgroundColor) : new Color(themeVars[DEFAULT_OVERBOOKING_COLOR]);
  }, [overbookingMaxLoad, themeVars]);

  return { overbookingColor };
};
